import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { LoadIdView } from '../../../models';
import {
  ShipmentLoadDemurrageAndDetentionTab,
  ShipmentLoadItemSetIdentifier,
  ShipmentLoadItemSetInitial,
} from './shipment-load-item.actions';
import { Observable, of } from 'rxjs';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { catchError, map } from 'rxjs/operators';
import { CustomHttpErrorResponse, Error, NotificationService } from '../../../../common';
import { ShipmentLoadItemService } from './shipment-load-item.service';

export interface ShipmentLoadItemStateModel {
  shipmentLoadIdentifier: LoadIdView;
  hasDemurrageAndDetention: boolean;
  loaded: boolean;
}

const initialState: ShipmentLoadItemStateModel = {
  shipmentLoadIdentifier: {
    loadNumber: null,
  },
  hasDemurrageAndDetention: false,
  loaded: false,
};

@State<ShipmentLoadItemStateModel>({
  name: 'shipmentLoadItem',
  defaults: initialState,
})
@Injectable()
export class ShipmentLoadItemState {
  @Selector()
  static getShipmentLoadIdentifier(state: ShipmentLoadItemStateModel): LoadIdView {
    return state.shipmentLoadIdentifier;
  }

  @Selector()
  static hasDemurrageAndDetentionTab(state: ShipmentLoadItemStateModel): boolean {
    return state.hasDemurrageAndDetention;
  }

  @Selector()
  static getLoaded(state: ShipmentLoadItemStateModel): boolean {
    return state.loaded;
  }

  @Action(ShipmentLoadItemSetIdentifier)
  setWaybillIdentifier(
    ctx: StateContext<ShipmentLoadItemStateModel>,
    { payload }: ShipmentLoadItemSetIdentifier,
  ): void {
    ctx.patchState({ ...ctx.getState(), shipmentLoadIdentifier: payload });
  }

  @Action(ShipmentLoadDemurrageAndDetentionTab)
  getShipmentLoadDemurrageAndDetentionTab(
    ctx: StateContext<ShipmentLoadItemStateModel>,
    { payload }: ShipmentLoadDemurrageAndDetentionTab,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentLoadItemService.getShipmentLoadDemurrageAndDetentionTab(payload).pipe(
      map((hasDemurrageAndDetention: boolean) => {
        ctx.patchState({ ...ctx.getState(), hasDemurrageAndDetention, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentLoadItemSetInitial)
  setInitialState(ctx: StateContext<ShipmentLoadItemStateModel>): void {
    ctx.setState(initialState);
  }

  constructor(
    private shipmentLoadItemService: ShipmentLoadItemService,
    private notificationService: NotificationService,
  ) {}
}
